import { SPACES } from "@/lib/studio";

export const AuthShell = ({ eyebrow, title, children, testId }) => (
  <main className="grid min-h-[calc(100vh-65px)] lg:grid-cols-2" data-testid={testId}>
    <div className="grain relative hidden overflow-hidden lg:block">
      <img src={SPACES[1].image} alt="Podcast room" className="absolute inset-0 h-full w-full object-cover opacity-60" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0C] via-transparent to-transparent" />
      <p className="absolute bottom-12 left-12 max-w-sm font-display text-3xl font-bold uppercase leading-tight text-white">
        Weekdays at the Factory. <span className="text-[#FF3333]">Bring the content.</span>
      </p>
    </div>
    <div className="flex items-center justify-center px-6 py-16">
      <div className="rise w-full max-w-md">
        <p className="eyebrow">{eyebrow}</p>
        <h1 className="mt-4 font-display text-4xl font-bold uppercase tracking-tight text-white">{title}</h1>
        <div className="mt-10">{children}</div>
      </div>
    </div>
  </main>
);
